import { PaymentIntegrationEventType, PaymentTransactionStatus } from 'models'

export const PAYMENT_INTEGRATION_ERROR = [
    PaymentTransactionStatus.Error,
    PaymentTransactionStatus.NoConnection,
    PaymentTransactionStatus.Rejected,
    PaymentTransactionStatus.Cancelled,
    PaymentTransactionStatus.Timeout,
    PaymentTransactionStatus.DeviceBusy,
    PaymentTransactionStatus.AmountNotValid,
]
export const PAYMENT_INTEGRATION_PROCESSING = [
    PaymentTransactionStatus.AwaitingDevice,
    PaymentTransactionStatus.AwaitingPayment,
]
export const PAYMENT_INTEGRATION_RETURN_TYPES = [
    PaymentIntegrationEventType.Void,
    PaymentIntegrationEventType.Return,
    PaymentIntegrationEventType.Refund,
]
export const PAYMENT_INTEGRATION_COMPLETE = [PaymentTransactionStatus.Completed]
